<template>
  <div>
    <v-col cols="12" class="text-center">
      <p class="mb-4">¿Estás seguro de que deseas eliminar este CUP? Esta acción no se puede deshacer.</p>
      <v-row justify="center">
        <v-col cols="auto">
          <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
        </v-col>
        <v-col cols="auto">
          <TextButton color="error" :loading="loading" @click="confirmEliminacion">Eliminar</TextButton>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@/components/base/TextButton.vue'

export default {
  name: 'ConfirmacionEliminarCupDialogComponent',
  components: {
    TextButton,
  },
  props: {
    onConfirm: { type: Function, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async confirmEliminacion() {
      this.loading = true
      try {
        await this.onConfirm()
        this.$emit('close')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
